import { useQuery } from '@tanstack/react-query';
import type { ContractListItem } from './types';

export interface ContractsResponse {
    totalContracts: number;
    totalNetworks: number;
    items: ContractListItem[];
}

export function useContracts() {
    return useQuery({ queryKey: ['ref-contracts'], queryFn: async () => (await (await fetch('/api/ref-contracts')).json()) as ContractsResponse });
}
